import UpdateProductInfo from "./UpdateProductInfo";

export default UpdateProductInfo;
